// The line under voice mode's stage: who hears the recruiter, and whose voice answers (27 Sep 2026).
// ElevenLabs and OpenAI hear and speak in one engine, and their own line says so; only the
// Transcribe engine hands her answers to Amazon Polly to read. Until this date Talk on ElevenLabs
// also said "her voice is Amazon Polly's", which was not true of it (voice-who.test.ts).
import { ELEVENLABS_HEARS } from './elevenlabs.ts';
import { OPENAI_HEARS } from './realtime.ts';

export function voiceWhoLine(whoHears: string): string {
  return whoHears === OPENAI_HEARS || whoHears === ELEVENLABS_HEARS
    ? `${whoHears}, which every recruiter can read.`
    : `${whoHears}; her voice is Amazon Polly’s, on the same account. Every turn is in this chat, and every recruiter can read it.`;
}
